import { render, staticRenderFns } from "./batch-upgrade.vue?vue&type=template&id=10d74674&scoped=true&"
import script from "./batch-upgrade.vue?vue&type=script&lang=js&"
export * from "./batch-upgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d74674",
  null
  
)

export default component.exports